export { default as StyledFlatTab } from './StyledFlatTab';
